/*
 * @description: 初始化表格组件
 * @Author: wxy
 * @Date: 2019-02-12 11:51:54
 */
import _ from 'lodash'
function init(config) {
  let page = _.cloneDeep(config)
  let height = window.screen.availHeight - 180 - 250
  if (page.pageSize === 'auto') {
    let pageArr = [10, 25, 50, 100]
    page.pageSizes = _.cloneDeep(pageArr)
    let pageNum = Math.round(height / 37)
    pageArr.push(pageNum)
    pageArr.sort(function (a, b) {
      return a - b
    })
    let index = pageArr.indexOf(pageNum)
    if (index === 0) {
      page.pageSize = pageArr[0]
    } else if (index === pageArr.length - 1) {
      page.pageSize = pageArr[pageArr.length - 1]
    } else {
      let prev = pageArr[index - 1]
      let next = pageArr[index + 1]
      if ((next - pageNum) < (pageNum - prev)) {
        page.pageSize = next
      } else {
        page.pageSize = prev
      }
    }
    // console.log('pageNum', pageNum, pageArr, page)
  }
  return page
}

export { init }



// WEBPACK FOOTER //
// ./src/components/tableUnit/utils/init.js